<template>
  <div :id="componentId" class="spm1-guest" :style="{ backgroundColor }">
    <div class="spm1-guest-scroll">
      <a
        v-for="(guest, idx) in guests"
        :key="idx"
        :class="['spm1-guest-card', { 'is-link': guest.jumpType === 2 }]"
        href="javascript:;"
        @click.prevent="handleClick(guest)"
      >
        <img class="spm1-guest-image" referrerpolicy="no-referrer" :src="guest.imageUrl" />
        <div class="spm1-guest-info">
          <span class="spm1-guest-name">{{ guest.name }}</span>
          <span class="spm1-guest-intro">{{ guest.introduction }}</span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileGuestShowcase',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_6'
    }
  },
  data() {
    return {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      guests: [
        {
          imageUrl: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNGa1953558fb341f2cea548f218709eada.png'),
          name: '张 超',
          introduction: '《中国品牌》杂志社社长',
          jumpType: 1,
          linkAddress: ''
        },
        {
          imageUrl: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNGa1953558fb341f2cea548f218709eada.png'),
          name: '胡晓云',
          introduction: '浙江大学CARD中国农业品牌研究中心主任',
          jumpType: 2,
          linkAddress: 'https://www.example.com/guest/2'
        },
        {
          imageUrl: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNGa1953558fb341f2cea548f218709eada.png'),
          name: '李 伟',
          introduction: '《中国品牌》杂志社副社长',
          jumpType: 1,
          linkAddress: ''
        },
        {
          imageUrl: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNGa1953558fb341f2cea548f218709eada.png'),
          name: '王 芳',
          introduction: '中国区域农业品牌研究中心主任',
          jumpType: 2,
          linkAddress: 'https://www.example.com/guest/4'
        },
        {
          imageUrl: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNGa1953558fb341f2cea548f218709eada.png'),
          name: '刘 明',
          introduction: '品牌战略专家',
          jumpType: 1,
          linkAddress: ''
        }
      ]
    }
  },
  methods: {
    handleClick(guest) {
      if (guest.jumpType !== 2 || !guest.linkAddress) return
      window.open(guest.linkAddress, '_blank')
    }
  }
}
</script>

<style scoped>
.spm1-guest {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.spm1-guest-scroll {
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  gap: 8px;
  scrollbar-width: none;
}

.spm1-guest-scroll::-webkit-scrollbar {
  display: none;
}

.spm1-guest-card {
  flex-shrink: 0;
  width: 120px;
  display: block;
  text-decoration: none;
  cursor: default;
}

.spm1-guest-card.is-link {
  cursor: pointer;
}

.spm1-guest-image {
  width: 120px;
  height: 132px;
  display: block;
  object-fit: cover;
  border-radius: 6px;
}

.spm1-guest-info {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.spm1-guest-name {
  font-size: 14px;
  color: #000;
  font-family: Microsoft YaHei-Regular;
  white-space: nowrap;
}

.spm1-guest-intro {
  font-size: 11px;
  color: #B0B0B0;
  line-height: 15px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
